export default __webpack_public_path__ + "static/media/TagLineUp.749d7b22.svg";